class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');

      if (!this.input) return;
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      //this.input.addEventListener('blur',  (e) => {
        //this.close();
     //});
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      try {
        if (!this.predictiveSearchResults) return;
        if (typeof navigator !== 'undefined' && 'onLine' in navigator && !navigator.onLine) {
          this.close();
          return;
        }
        fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
          .then((response) => {
            if (!response.ok) {
              this.close();
              return null;
            }
            return response.text();
          })
          .then((text) => {
            if (!text) return;
            try {
              const doc = new DOMParser().parseFromString(text, 'text/html');
              const section = doc.querySelector('#shopify-section-predictive-search');
              if (!section) {
                this.close();
                return;
              }
              this.predictiveSearchResults.innerHTML = section.innerHTML;
              this.open();
            } catch (err) {
              this.close();
            }
          })
          .catch((error) => {
            this.close();
          });
      } catch (err) {
        try { this.close(); } catch (e) {}
      }
    }
  
    open() {
      if (!this.predictiveSearchResults || !this.predictiveSearchResults.parentElement) return;
      this.predictiveSearchResults.parentElement.classList.add('show-results');
    }
  
    close() {
      if (!this.predictiveSearchResults || !this.predictiveSearchResults.parentElement) return;
      this.predictiveSearchResults.parentElement.classList.remove('show-results');
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  customElements.define('predictive-search', PredictiveSearch);